export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manawubr.f0efe50e.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};